import { z } from 'zod';
import { LICENSE_CODES, type LicenseCode } from '../../../../types/licenses';

export const BasicBusinessInformationSchema = z.object({
  licenseCode: z.enum(LICENSE_CODES as [LicenseCode, ...LicenseCode[]]),
});

export type BusinessInformation = Record<string, unknown> & z.infer<typeof BasicBusinessInformationSchema>;
